export default {
  2011: {
    items: [
      "Afghanistan",
      "Argentina",
      "Austria",
      "Bangladesh",
      "Bhutan",
      "Bosnia and Herzegovina",
      "Brazil",
      "Brunei",
      "Burma (Republic of the Union of Myanmar)",
      "Cambodia",
      "Canada",
      "Chile",
      "China (excludes SARs and Taiwan)",
      "Colombia",
      "Congo, Democratic Republic of",
      "Cook Islands",
      "Croatia",
      "Cyprus",
      "Czech Republic",
      "Denmark",
      "Egypt",
      "El Salvador",
      "England",
      "Eritrea",
      "Ethiopia",
      "Fiji",
      "Finland",
      "France",
      "Germany",
      "Ghana",
      "Greece",
      "Hong Kong (SAR of China)",
      "Hungary",
      "India",
      "Indonesia",
      "Iran",
      "Iraq",
      "Ireland (Northern)",
      "Ireland (Republic of)",
      "Israel",
      "Italy",
      "Japan",
      "Kenya",
      "Korea, Republic of (South)",
      "Lebanon",
      "Liberia",
      "Malaysia",
      "Malta",
      "Mauritius",
      "Nepal",
      "Netherlands",
      "New Zealand",
      "Nigeria",
      "North Macedonia",
      "Pakistan",
      "Papua New Guinea",
      "Philippines",
      "Poland",
      "Portugal",
      "Romania",
      "Russian Federation",
      "Samoa",
      "Scotland",
      "Sierra Leone",
      "Singapore",
      "Somalia",
      "South Africa",
      "South Sudan",
      "Spain",
      "Sri Lanka",
      "Sudan",
      "Sweden",
      "Switzerland",
      "Syria",
      "Taiwan",
      "Tanzania",
      "Thailand",
      "Timor-Leste",
      "Türkiye",
      "Uganda",
      "Ukraine",
      "United Arab Emirates",
      "United States of America",
      "Vietnam",
      "Wales",
      "Zambia",
      "Zimbabwe"
    ]
  },
  2016: {
    items: [
      "Afghanistan",
      "Argentina",
      "Austria",
      "Bangladesh",
      "Bhutan",
      "Bosnia and Herzegovina",
      "Brazil",
      "Brunei",
      "Burma (Republic of the Union of Myanmar)",
      "Cambodia",
      "Canada",
      "Chile",
      "China (excludes SARs and Taiwan)",
      "Colombia",
      "Congo, Democratic Republic of",
      "Cook Islands",
      "Croatia",
      "Cyprus",
      "Czech Republic",
      "Denmark",
      "Egypt",
      "El Salvador",
      "England",
      "Eritrea",
      "Ethiopia",
      "Fiji",
      "Finland",
      "France",
      "Germany",
      "Ghana",
      "Greece",
      "Hong Kong (SAR of China)",
      "Hungary",
      "India",
      "Indonesia",
      "Iran",
      "Iraq",
      "Ireland (Northern)",
      "Ireland (Republic of)",
      "Israel",
      "Italy",
      "Japan",
      "Kenya",
      "Korea, Republic of (South)",
      "Lebanon",
      "Liberia",
      "Malaysia",
      "Malta",
      "Mauritius",
      "Nepal",
      "Netherlands",
      "New Zealand",
      "Nigeria",
      "North Macedonia",
      "Pakistan",
      "Papua New Guinea",
      "Philippines",
      "Poland",
      "Portugal",
      "Romania",
      "Russian Federation",
      "Samoa",
      "Scotland",
      "Sierra Leone",
      "Singapore",
      "Somalia",
      "South Africa",
      "South Sudan",
      "Spain",
      "Sri Lanka",
      "Sudan",
      "Sweden",
      "Switzerland",
      "Syria",
      "Taiwan",
      "Tanzania",
      "Thailand",
      "Timor-Leste",
      "Türkiye",
      "Uganda",
      "Ukraine",
      "United Arab Emirates",
      "United States of America",
      "Vietnam",
      "Wales",
      "Zambia",
      "Zimbabwe"
    ]
  },
  2021: {
    items: [
      "Afghanistan",
      "Argentina",
      "Austria",
      "Bangladesh",
      "Bhutan",
      "Bosnia and Herzegovina",
      "Brazil",
      "Brunei",
      "Burma (Republic of the Union of Myanmar)",
      "Cambodia",
      "Canada",
      "Chile",
      "China (excludes SARs and Taiwan)",
      "Colombia",
      "Congo, Democratic Republic of",
      "Cook Islands",
      "Croatia",
      "Cyprus",
      "Czech Republic",
      "Denmark",
      "Egypt",
      "El Salvador",
      "England",
      "Eritrea",
      "Ethiopia",
      "Fiji",
      "Finland",
      "France",
      "Germany",
      "Ghana",
      "Greece",
      "Hong Kong (SAR of China)",
      "Hungary",
      "India",
      "Indonesia",
      "Iran",
      "Iraq",
      "Ireland (Northern)",
      "Ireland (Republic of)",
      "Israel",
      "Italy",
      "Japan",
      "Kenya",
      "Korea, Republic of (South)",
      "Lebanon",
      "Liberia",
      "Malaysia",
      "Malta",
      "Mauritius",
      "Nepal",
      "Netherlands",
      "New Zealand",
      "Nigeria",
      "North Macedonia",
      "Pakistan",
      "Papua New Guinea",
      "Philippines",
      "Poland",
      "Portugal",
      "Romania",
      "Russian Federation",
      "Samoa",
      "Scotland",
      "Sierra Leone",
      "Singapore",
      "Somalia",
      "South Africa",
      "South Sudan",
      "Spain",
      "Sri Lanka",
      "Sudan",
      "Sweden",
      "Switzerland",
      "Syria",
      "Taiwan",
      "Tanzania",
      "Thailand",
      "Timor-Leste",
      "Türkiye",
      "Uganda",
      "Ukraine",
      "United Arab Emirates",
      "United States of America",
      "Vietnam",
      "Wales",
      "Zambia",
      "Zimbabwe"
    ]
  }
};



// WEBPACK FOOTER //
// ../data/wa/birthplace.js